import React from "react";
import _ from "lodash";
import { inject, observer } from "mobx-react";

/// Button UI
import ToggleButton from "component/atoms/ToggleButton";
import ToggleButtonGroup from "component/atoms/ToggleButtonGroup";
import Dropdown from "component/atoms/Dropdown";

/// Expanded UI (with Button UI)
import {
  LayoutChooserContainer,
  SynchronizationDropdownContainer,
  InfoDropdownContainer,
  MeasureDropdownContainer,
  ContrastDropdownContainer,
  MPRDropdownContainer,
} from "pages/viewer-dashboard/container/";
import { clearAll } from "component/toolManager/toolState";
import Constants from "constants/index";
import Helper from "helper";
import Config from "config";
/// Resources
import SVGIcons from "assets/icon";
import "./toolbarSection.styl";

@inject("metadataStore")
@inject("synchronizationStore")
@inject("seriesListStore")
@inject("toolbarStore")
@inject("gridLayoutStore")
@observer
class ToolbarSection extends React.PureComponent {
  /**
   * Creates an instance of ToolbarSection.
   * @param {IToolbarSectionProps} props
   * @memberof ToolbarSection
   */
  constructor(props) {
    super(props);
    this.state = {
      isUseLink: 1,
      isUseInfo: 1,
      isUseMPR: 1,
    };
  }

  componentDidMount() {
    const { toolbarStore } = this.props;
    toolbarStore.activateViewportToolName("BrowseSeries");
    window.addEventListener("resize", this.handleResize);
  }

  getSynchronizationIcon(syncState) {
    let syncIcon = SVGIcons.SVGLinkIcon;
    switch (syncState) {
      case Constants.Synchronization.SYNC_AUTO:
        syncIcon = SVGIcons.SVGLinkAutoIcon;
        break;
      case Constants.Synchronization.SYNC_MANUAL:
        syncIcon = SVGIcons.SVGLinkManualIcon;
        break;
      case Constants.Synchronization.SYNC_DISABLE:
        syncIcon = SVGIcons.SVGLinkUnlinkIcon;
        break;
      default:
        Helper.Except.throw("ToolbarSection Render : undefined sync state");
        break;
    }

    if (Helper.Validator.isDefined(syncIcon) === false) {
      Helper.Except.throw("Failed to get synchronization icon");
    }

    return syncIcon;
  }

  handleResize = (value) => {
    const { toolbarStore } = this.props;
    var isFullscreen = toolbarStore.isFullscreen();

    /// 전체화면 감지 방법.
    /// Hack: Chrome에서만 동작하며, 브라우저에 따른 감지방법에 대해 조사가 필요함.
    // eslint-disable-next-line no-restricted-globals
    if (
      // eslint-disable-next-line no-restricted-globals
      screen.width !== window.innerWidth ||
      // eslint-disable-next-line no-restricted-globals
      screen.height !== window.innerHeight
    ) {
      if (isFullscreen === false) {
        return;
      }
      toolbarStore.toggleFullscreenState();
      return;
    }
    if (isFullscreen === true) {
      return;
    }
    toolbarStore.toggleFullscreenState();
  };

  handleLinkToolButtonClick = (value) => {
    const { synchronizationStore } = this.props;
    const isActive = synchronizationStore.isSyncActive();

    if (synchronizationStore.isSupportedSynchronizationOnActive() === true) {
      synchronizationStore.toggleSyncState();
    } else {
      synchronizationStore.disableSyncState();
    }
    if (isActive === true) {
      this.setState({ isUseLink: value });
      synchronizationStore.activateSync(true);
    } else {
      this.setState({ isUseLink: -1 });
      synchronizationStore.activateSync(false);
    }
    // const { synchronizationStore } = this.props;

    // if (value.length > 1) {
    //   this.setState({ isUseLink: value });
    //   synchronizationStore.activateSync(true);
    // } else {
    //   this.setState({ isUseLink: -1 });
    //   synchronizationStore.activateSync(false);
    // }
  };

  /**
   * @method handleLayoutChoosing
   * @description Layout 버튼 클릭시 나타나는 LayoutChooser UI에서
   * Layout을 선택하면 DCMViewer에 레이아웃 변경 메세지를 전송한다.
   * @memberof ToolbarSection
   */
  handleLayoutChoosing = (rowIndex, columnIndex) => {
    const { gridLayoutStore } = this.props;

    //gridLayoutStore.changeLayout(rowIndex + 1, columnIndex + 1, 1);
    const pages = gridLayoutStore.getLayoutTotalPages();
    gridLayoutStore.changeLayout(rowIndex + 1, columnIndex + 1, pages);
  };

  handleLinkButtonClick = (event, isActive) => {
    const { synchronizationStore } = this.props;
    synchronizationStore.activateSync(isActive);
  };

  handleFullscreenButtonClick = (event, isActive) => {
    const { toolbarStore } = this.props;
    toolbarStore.toggleFullscreen();
  };

  /**
   * @method handleContextMenu
   * @description 우측마우스 클릭시, 기본 Context 표시를 막는다.
   * @param {*} e
   */
  handleContextMenu = function (e) {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.preventDefault();
  };

  handleChangedMode = (e) => {
    const { toolbarStore } = this.props;
    if (Config.control.AllocateAllFramesOnLayout === true) {
      const { gridLayoutStore } = this.props;
      this.clickTimer = window.setTimeout(function (that) {
        //gridLayoutStore.setLayoutTotalPages(1);
        gridLayoutStore.setLayoutTotalPages(1);
        gridLayoutStore.changeLayout(1, 1);
        gridLayoutStore.focusOneLayout(-1);
      }, 0);
    } else {
      this.clickTimer = window.setTimeout(
        function (that) {
          const {
            gridLayoutStore,
            seriesListStore,
            metadataStore,
          } = this.props;

          // Split series
          const metadataID = seriesListStore.getActiveSeriesItem();

          /// 1. 페이지 개수 계산
          // 고정
          //gridLayoutStore.changeLayout(3, 4);
          gridLayoutStore.changeLayout(2, 3);
          const numOfFrames = metadataStore.getNumberOfFrames(metadataID);
          const numOfViews =
            gridLayoutStore.getLayoutRows() *
            gridLayoutStore.getLayoutColumns();
          const alpha = numOfFrames % numOfViews > 0 ? 0 : 1;
          //const numOfPages = numOfFrames / numOfViews + alpha;
          const numOfPages = Math.ceil(numOfFrames / numOfViews) + alpha;

          /// 2. 페이지 설정
          // 레이아웃 변경
          gridLayoutStore.setLayoutTotalPages(numOfPages);
          gridLayoutStore.focusOneLayout(-1);
          /// 3. DCM View 슬라이스 일괄 출력 요청 정보 정의
          let requestView = [];
          for (let i = 0; i < numOfFrames; i++) {
            requestView.push({
              DCMViewIdx: i,
              active: i === 0 ? true : false,
              MetadataUID: metadataID,
              frameIdx: i,
              BatchMode: true,
              imageOrientation: "axial",
              showTagOverlay: true,
            });
          }

          /// 4. 현재 DCMView에서 그리기 정보 모두 삭제
          clearAll();

          /// 5. 일괄 출력 요청
          gridLayoutStore.setMetadataOnViewAsList(requestView);
        }.bind(this),
        0
      );
    }
    toolbarStore.toogleBatchViewMode(e);
  };

  /**
   * @method render
   * @description ToolbarSection UI 컴포넌트 렌더링
   * @returns 렌더링된 ToolbarSection React Element
   * @memberof ToolbarSection
   */
  render() {
    const { toolbarStore, seriesListStore, synchronizationStore } = this.props;
    //const { isUseLink, isUseInfo } = this.state;
    const { isUseInfo, isUseMPR } = this.state;
    // 동기화 기능 상태에 따른 표기 아이콘 획득
    const syncState = synchronizationStore.getSyncState();
    const syncIcon = this.getSynchronizationIcon(syncState);
    const isSyncActive = synchronizationStore.isSyncActive();
    let isUseLink = -1;
    if (isSyncActive === true) {
      isUseLink = 5;
    }

    return (
      <React.Fragment>
        <div className="toolbarSection" onContextMenu={this.handleContextMenu}>
          {
            ///
            /// 좌측부터 차례대로 버튼 UI 추가
            ///
          }
          <div
            className="toolbarSectionTools pull-left nodrag noselect"
            onContextMenu={this.handleContextMenu}
          >
            <ToggleButtonGroup
              type="checkbox"
              value={toolbarStore.isOpenSeriesList()}
              className="toolbarButtonGroup"
              onChange={(value) => {
                //toolbarStore.toggleOpenSeriesList(value);
                seriesListStore.toggleIsOpen();
                Helper.Events.fireResizeEventOnWindow();
              }}
            >
              <ToggleButton
                label={"Series"}
                className="toolbarSectionButton"
                SVGIcon={SVGIcons.SVGSeriesIcon}
                value={1}
                as={"SVGTypeButton"}
              />
            </ToggleButtonGroup>
            <ToggleButtonGroup
              type="checkbox"
              value={2}
              className="toolbarButtonGroup"
            >
              <ToggleButton
                id={"link-toggle-button"}
                label={"Layout"}
                SVGIcon={SVGIcons.SVGLayoutIcon}
                disabled={toolbarStore.isBatchViewMode() ? true : false}
                value={6}
                className="toolbarSectionButton"
                as={"SVGDropdownTypeButton"}
              >
                {toolbarStore.isBatchViewMode() ? (
                  ""
                ) : (
                  <Dropdown.Menu bsPrefix="dropdown-menu--toolbar dropdown-menu--toolbar__unvisible">
                    <LayoutChooserContainer
                      onCellClick={this.handleLayoutChoosing}
                    />
                  </Dropdown.Menu>
                )}
              </ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup
              type="radio"
              name={"toolOption"}
              className="toolbarButtonGroup"
              value={toolbarStore.getBatchViewMode()}
              onChange={this.handleChangedMode}
            //onChange={toolbarStore.toogleBatchViewMode}
            >
              <ToggleButton
                label={"SplitSeries"}
                //SVGIcon={SVGIcons.SVGPanIcon}
                SVGIcon={SVGIcons.SVGSplitSeries1Icon}
                value={0}
                className="toolbarSectionButton"
                as={"SVGTypeButton"}
              />
            </ToggleButtonGroup>
            <ToggleButtonGroup
              type="radio"
              name={"toolOption"}
              className="toolbarButtonGroup"
              value={toolbarStore.getSelectedToolType()}
              onChange={toolbarStore.toogleViewportToolType}
            >
              <ToggleButton
                label={"Pan"}
                SVGIcon={SVGIcons.SVGPanIcon}
                value={1}
                className="toolbarSectionButton"
                as={"SVGTypeButton"}
              />
              <ToggleButton
                label={"Zoom"}
                SVGIcon={SVGIcons.SVGZoomIcon}
                value={2}
                className="toolbarSectionButton"
                as={"SVGTypeButton"}
              />
              <ToggleButton
                id={"contrast-toggle-button"}
                label={"Contrast"}
                SVGIcon={SVGIcons.SVGContrastIcon}
                onClickDropdownButton={() => {
                  toolbarStore.setSelectedToolType(3);
                  toolbarStore.activateViewportToolType(3);
                }}
                value={3}
                className="toolbarSectionButton"
                as={"SVGDropdownSplitTypeButton"}
              >
                <ContrastDropdownContainer />
              </ToggleButton>

              <ToggleButton
                id={"measure-toggle-button"}
                label={"Measure"}
                SVGIcon={SVGIcons.SVGMeasureIcon}
                onClickDropdownButton={() => {
                  toolbarStore.setSelectedToolType(4);
                  toolbarStore.activateViewportToolType(4);
                  toolbarStore.reactivateMeasureTypeTool();
                }}
                value={4}
                className="toolbarSectionButton"
                as={"SVGDropdownSplitTypeButton"}
              >
                <MeasureDropdownContainer />
              </ToggleButton>
            </ToggleButtonGroup>

            <ToggleButtonGroup
              type="checkbox"
              name={"linkTool"}
              className="toolbarButtonGroup"
              value={isUseLink}
              onChange={this.handleLinkToolButtonClick}
            >
              <ToggleButton
                id={"link-toggle-button"}
                label={"Link"}
                SVGIcon={syncIcon}
                // onClickDropdownButton={() => {
                //   this.setState({ isUseLink: 5 });
                //   synchronizationStore.activateSync(true);
                // }}
                onClickDropdownButton={() => {
                  if (isSyncActive === true) {
                    this.setState({ isUseLink: 5 });
                    synchronizationStore.activateSync(true);
                  } else {
                    this.setState({ isUseLink: -1 });
                    synchronizationStore.activateSync(false);
                  }
                }}
                value={5}
                className="toolbarSectionButton"
                as={"SVGDropdownSplitTypeButton"}
                onClick={this.handleLinkButtonClick}
              >
                <SynchronizationDropdownContainer />
              </ToggleButton>
            </ToggleButtonGroup>
            {!!Config.privateSupport.isEnableImageFusion && (
              <ToggleButtonGroup
                type="radio"
                name={"imageFusion"}
                className="toolbarButtonGroup"
                value={toolbarStore.getImageFusionButtonState()}
                onChange={() => {
                  toolbarStore.toggleImageFusion();
                }}
              >
                <ToggleButton
                  label={"Fusion"}
                  SVGIcon={SVGIcons.SVGImageFusionIcon}
                  value={1}
                  className="toolbarSectionButton"
                  as={"SVGTypeButton"}
                />
              </ToggleButtonGroup>
            )}
            {!!Config.privateSupport.isEnableImageFusion && (
              <ToggleButtonGroup
                type="checkbox"
                name={"MPR"}
                className="toolbarButtonGroup"
                value={isUseMPR}
              >
                <ToggleButton
                  id={"mpr-toggle-button"}
                  label={"MPR"}
                  SVGIcon={SVGIcons.SVGMPRIcon}
                  onClickDropdownButton={() => {
                    this.setState({ isUseMPR: 6 });
                  }}
                  value={6}
                  className="toolbarSectionButton"
                  as={"SVGDropdownTypeButton"}
                >
                  <MPRDropdownContainer />
                </ToggleButton>
              </ToggleButtonGroup>
            )}
            <ToggleButtonGroup
              type="checkbox"
              name={"info"}
              className="toolbarButtonGroup"
              value={isUseInfo}
            >
              <ToggleButton
                id={"info-toggle-button"}
                label={"Info"}
                SVGIcon={SVGIcons.SVGInfoIcon}
                onClickDropdownButton={() => {
                  this.setState({ isUseInfo: 6 });
                }}
                value={6}
                className="toolbarSectionButton"
                as={"SVGDropdownTypeButton"}
              >
                <InfoDropdownContainer />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          {
            ///
            /// 우측부터 차례대로 버튼 UI 추가
            ///
          }
          <div className="toolbarSectionTools pull-right nodrag noselect">
            <ToggleButtonGroup
              type="checkbox"
              value={toolbarStore.isFullscreen() ? 1 : 0}
              className="toolbarButtonGroup"
              onChange={this.handleFullscreenButtonClick}
            >
              <ToggleButton
                label={"Fullscreen"}
                className="toolbarSectionButton"
                SVGIcon={SVGIcons.SVGFullscreenIcon}
                value={1}
                as={"SVGTypeButton"}
              />
            </ToggleButtonGroup>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ToolbarSection;
